import { BackendResponseModel, RawHttpErrorResponse } from '../../models';

export abstract class BaseErrorHandler {
  httpResponseError?: RawHttpErrorResponse;
  abstract handle(): BackendResponseModel;
  abstract canHandle(): boolean;
}
